module.exports = __webpack_public_path__ + "static/media/hitachilogored.875adac3.png";